module.exports = __webpack_public_path__ + "static/media/edit.90f687e0.svg";